import React from 'react';
import './index.css';
import {
    connect
} from 'react-redux';
import {
    actionCreators
} from 'courseProjectStore';

import {Tabs, WingBlank, WhiteSpace } from 'antd-mobile';
import { StickyContainer, Sticky } from 'react-sticky';

import TabIntro from '../tabIntro';
import TabAttachment from '../tabAttachment'
import TabWorks from '../tabWorks'
import TabCatalog from '../tabCatalog'
const tabs = [
  { title: '课程介绍' },
  { title: '目录' },
  { title: '附件' },
  { title: '优秀作品' },
];
function renderTabBar(props) {
  return (<Sticky>
    { ({ style }) => <div style={{ ...style, zIndex: 20,top:'45px' }}><Tabs.DefaultTabBar {...props} /></div> }
  </Sticky>);
}

class InfoTab extends React.Component{
  render(){
    const {subject,info,excellentList,attachmentList, finishedList, user_id, permission, finishedListLock} = this.props
    return (
      <div className="info-tab">
        <StickyContainer>
          <Tabs tabs={tabs}
            swipeable={false}
            initalPage={'t2'}
            renderTabBar={renderTabBar}>
            <div className="tab-main">
              <WingBlank>
                <TabIntro info = {info}/>
              </WingBlank>
            </div>
            <div className="tab-main">
              <WingBlank>
                {/*目录*/}
                <TabCatalog permission={permission} 
                subject={subject} info={info.toJS()} id = {info.get('id')} finishedList = {finishedList} finishedListLock = {finishedListLock}/>
              </WingBlank>
            </div>
            <div className="tab-main">
              <WingBlank>
                <TabAttachment attachmentList={attachmentList}/>
              </WingBlank>
            </div>
            <div className="tab-main">
              <WingBlank>
                <TabWorks data={excellentList}/>
              </WingBlank>
            </div>
          </Tabs>
        </StickyContainer>
      </div>
      )
  }
}


const mapState = (state) => ({
    subject: state.getIn(['courseproject', 'info','subject']),
    info: state.getIn(['courseproject', 'info']),
    excellentList: state.getIn(['courseproject', 'excellentList']),
    attachmentList: state.getIn(['courseproject', 'attachmentList']),
    finishedList: state.getIn(['courseproject', 'finishedList']),
    finishedListLock: state.getIn(['courseproject', 'finishedListLock']),
    user_id: state.getIn(['home','userinfo', 'user_id']),
})


export default connect(mapState, null)(InfoTab);
